import React from 'react';
import { useTranslation } from '@/hooks/useTranslation';

interface PageSizeSelectorProps {
    pageSize: number;
    onPageSizeChange: (size: number) => void;
    options?: number[];
}

export default function PageSizeSelector({
    pageSize,
    onPageSizeChange,
    options = [10, 20, 50, 100]
}: PageSizeSelectorProps) {
    const { t } = useTranslation();
    return (
        <div className="flex items-center space-x-2 flex-wrap justify-center">
            <label htmlFor="page-size" className="text-sm text-muted-foreground whitespace-nowrap">
                <span className="hidden lg:inline">{t('pagination.show')}:</span>
            </label>
            <select
                id="page-size"
                value={pageSize}
                onChange={(e) => onPageSizeChange(Number(e.target.value))}
                className="px-2 py-1 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400 min-w-[60px]"
            >
                {options.map((size) => (
                    <option key={size} value={size}>
                        {size}
                    </option>
                ))}
            </select>
            <span className="text-sm text-muted-foreground whitespace-nowrap">
                <span className="hidden lg:inline">{t('pagination.per_page')}</span>
            </span>
        </div>
    );
} 